// load jQuery and popper.js
import 'jquery';
import 'popper.js';
window.$ = window.jQuery = $;

// load Bootstrap
import 'bootstrap';

// load Choices
import Choices from "choices.js";

// load Boostrap Table
import 'tableexport.jquery.plugin';
import 'bootstrap-table/dist/bootstrap-table';
import 'bootstrap-table/dist/locale/bootstrap-table-de-DE';
import 'bootstrap-table/dist/extensions/export/bootstrap-table-export';
import 'bootstrap-table/dist/extensions/filter-control/bootstrap-table-filter-control';

// Use Font Awesome icons in boostrap-table instead of default Bootstrap icons
$.fn.bootstrapTable.defaults.iconsPrefix = 'fa';

// load input mask
import Inputmask from 'inputmask';

// load Sortable.js
import Sortable from 'sortablejs';
window.Sortable = Sortable;

// initialize choices.js inputs
window.choicesConfig = function(elem) {
  const isMultiple = elem.hasAttribute('multiple');
  const hasPlaceholder = elem.hasAttribute('data-placeholder');
  const hasEmptyOption = elem.options.length && elem.options[0].value === "";
  const restoreAmp = (value) => value.replace('&amp;', '&');

  return {
    removeItemButton: hasEmptyOption || isMultiple,
    searchEnabled: elem.options.length > 8,
    searchResultLimit: 30,
    searchFields: ['label', 'value', 'element.dataset.subtext', 'customProperties.subtext'],
    shouldSort: false,
    placeholderValue: !isMultiple || hasPlaceholder ? null : '-- Bitte wählen --',
    loadingText: 'Lädt...',
    noResultsText: 'Keine Ergebnisse gefunden',
    noChoicesText: 'Keine Auswahl vorhanden',
    itemSelectText: '',
    classNames: {
      ...Choices.defaults.allOptions.classNames,
      containerOuter: [
        ...Choices.defaults.allOptions.classNames.containerOuter,
        ...(elem.dataset.containerClass ? elem.dataset.containerClass.split(' ') : []),
      ],
    },
    callbackOnCreateTemplates: () => ({
      choice: (...args) => {
        const div = Choices.defaults.templates.choice.call(this, ...args);
        div.textContent = restoreAmp(div.textContent);
        let subtext = null;
        const choice = args[1] // args[1] is ChoiceFull object
        if (choice.element.dataset.subtext) subtext = choice.element.dataset.subtext;
        else if (choice.customProperties.subtext) subtext = choice.customProperties.subtext;
        if (subtext) {
          const smallElement = document.createElement('small');
          smallElement.className = 'text-muted ps-2';
          smallElement.textContent = subtext;
          div.append(smallElement)
        }
        return div;
      },
      item: (...args) => {
        const div = Choices.defaults.templates.item(...args);
        div.childNodes[0].textContent = restoreAmp(div.childNodes[0].textContent);
        return div;
      }
    })
  };
};
$('.js-choice').each(function () {
  this.choices = new Choices(this, window.choicesConfig(this));
});
// only set placeholder for multi-selects when no item is selected
const multiplePlaceholder = function(elem) {
  elem.choices.input.element.placeholder = !elem.selectedOptions.length ? elem.choices._placeholderValue : '';
  elem.choices.input.setWidth(); // recalculate input width
};
const choicesMultiple = $('.js-choice[multiple]');
choicesMultiple.each(function() {
  multiplePlaceholder(this)
});
choicesMultiple.on('addItem', function() {
  multiplePlaceholder(this);
});
choicesMultiple.on('removeItem', function() {
  multiplePlaceholder(this);
});


// globally initialize popovers, tooltips and onclick chevron switches
$(document).ready(function() {
  $('[data-bs-toggle="tooltip"]').tooltip();
});

$(document).ready(function() {
  $('body').popover({
    container: 'body',
    html: true,
    selector: '[data-bs-toggle="popover"]',
    trigger: 'click hover',
  });
});

$('.switch-chevron-onclick').click(function(e) {
  $(e.target).find('.chevron-item').toggle();
});

// initialize input masks
$(document).ready(function() {
  Inputmask().mask([...document.querySelectorAll('input')]
      .filter(el => [...el.attributes]
          .filter(({name}) => name.startsWith('data-inputmask'))
          .length
      )
  );
});

// define a sorter for sorting dd.mm.yyyy date values
window.TableSorterDate = function(v1, v2) {
  const replacer = function(match, p1, p2, p3) {
    return [p3, p2, p1].join('');
  };

  let d1 = v1.replace(/^(\d\d)\.(\d\d).(\d\d\d\d)/, replacer);
  let d2 = v2.replace(/^(\d\d)\.(\d\d).(\d\d\d\d)/, replacer);

  d1 = d1.replace(/\D/g, '');
  d2 = d2.replace(/\D/g, '');

  return d1 - d2;
};

// can be used as custom filter function for Bootstrap Table in <th> via attribute:
// data-filter-custom-search="TableFilterContains"
window.TableFilterContains = function(text, value) {
  return value.toLowerCase().includes(text);
};

// custom filter function for Bootstrap Table to compare to values
// parameter text (the search text) should be a string containing the operand and the search value, separated by ':'
window.TableFilterCompareTo = function(text, value) {
  value = Number(value);
  const operator = text.split(':')[0];
  const compareValue = Number(text.split(':')[1]);

  if (isNaN(value)) {
    return false;
  }
  if (isNaN(compareValue)) {
    throw new TypeError('Comparative value could not be converted to type number.');
  }

  switch (operator) {
    case '=': return value === compareValue;
    case '>': return value > compareValue;
    case '<': return value < compareValue;
    case '>=': return value >= compareValue;
    case '<=': return value <= compareValue;
    default: throw new Error('Operation' + operator + 'not supported.');
  }
};

// set up copy to clipboard feature
$(document).on('click', '.copy-to-clipboard', function(e) {
  const elem = $(e.target);
  const temp = $('<input>');
  $('body').append(temp);
  temp.val(elem.attr('data-value')).select();
  navigator.clipboard.writeText(temp.val())
      .then(() => alert(elem.attr('data-confirm')))
      .finally(temp.remove());
});

// load global CSS
import './app.scss';

// load the different modules
import './application';
import './course-management';
import './curriculum-management';
import './faculty-management';
import './sap-import';
import './student-management';
import './mobility-management';
import './room-booking-management';
import './event-management';
